module.exports = __webpack_public_path__ + "img/14.1a61ac7a.png";